module.exports = __webpack_public_path__ + "img/fileinput.b9d99b1d.png";